import * as React from 'react';
import styled from 'styled-components';
import { LG } from '@origin-digital/helper';
import { Heading3 } from '@origin-digital/style-guide';

interface HeadingProps {
  text: string;
}

const Heading: React.FC<HeadingProps> = ({ text }) => (
  <HeadingTextContainer data-id="heading-container">
    <Heading3 text={text} data-id="heading" />
  </HeadingTextContainer>
);

export { Heading };

const HeadingTextContainer = styled.div`
  margin-bottom: 16px;
  ${LG`
    margin-bottom: 24px;
  `}
`;
